// extracted by mini-css-extract-plugin
module.exports = {"container":"StageImage_container__EwM1f","image":"StageImage_image__LQucy"};